import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'
import './styles/index.scss'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 捕获并忽略 Vue Router 的导航重定向错误
const originalConsoleError = console.error
console.error = function(...args) {
  const message = args[0]
  if (typeof message === 'string' && message.includes('Redirected when going from')) {
    return // 忽略导航重定向错误
  }
  originalConsoleError.apply(console, args)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
